import { useMutation, useQuery } from "@tanstack/react-query";
import { createShiftSchedule, getShiftSchedule } from ".";
import {
  AddWorkScheduleCommand,
  WorkScheduleListParams,
} from "@/models/club";

const useShiftSchedule = (params: WorkScheduleListParams) =>
  useQuery({
    queryKey: ["get-shift-schedule", params],
    queryFn: () => getShiftSchedule(params),
    select: (res) => res,
  });

const useCreateShiftSchedule = () =>
  useMutation({
    mutationFn: (data: AddWorkScheduleCommand) => createShiftSchedule(data),
  });

export { useShiftSchedule, useCreateShiftSchedule };
